import Vue from 'vue'
import App from '@/App.vue'
Vue.config.productionTip = false


Vue.prototype.$uploadUrl = 'https://gnjyht.gagasaas.com/common/file/upload'
// Vue.prototype.$uploadUrl = 'http://127.0.0.1:9000/common/file/upload'



import store from "@/store/index.js"
import router from '@/router/index.js'
// 导入 axios 请求配置文件，并挂在到Vue
import request from '@/utils/request.js'
Vue.prototype.$H = request
// 导入时间过滤器
import { dateFormat } from '@/utils/dateFilter.js'
Vue.filter('dateFormat', dateFormat)
// 导入消息提示
import msg from '@/utils/message.js'
Vue.prototype.$msg = msg
// 引入element插件加载文件
import '@/plugins/element.js'
// // 引入全局样式文件
import '@/assets/css/global.css'
// // 引入自定义样式文件
import '@/assets/css/custom.css'



new Vue({ router, render: h => h(App), store }).$mount('#app')

